import { DataBean } from "../DataBean";

export class ElectronicPayroll extends DataBean {



    public async getElectronicPayrollCatalog(valueType: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getElectronicPayrollCatalog_Number_String_Number_Number", [valueType, regexStr, page, recordsPerPage]);
    }

    public async deleteElectronicPayroll(idElectronicPayroll: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteElectronicPayroll_Number", [idElectronicPayroll]);
    }
    public async updateElectronicPayroll(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.ElectronicPayroll_updateElectronicPayroll_employees.ElectronicPayroll", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "employees.ElectronicPayroll"
            }
        ]);
    }



}